<template>
    <modal :name="propsName" width="100%" height="100%" :max-width="800" :max-height="700" :adaptive="true"
        styles="background: rgba(255, 255, 255, .85); border-radius: 10px;" :click-to-close="false">
        <div class="modal modal-confirm">
            <div class="modal-content">
                <a href="javascript:void(0);" class="bt-modal-close bt" data-iziModal-close=".modal-detail-1">
                    <img :src="`@/${getIcoModalClosePath()}`" alt="" v-on:click="hide"/>
                </a>
                <p class="order-modal-header">施設を選択してください</p><br>                
                <p v-if="clinicList.length == 0" class="billing-user-select-modal-area-text">選択できる出庫先が存在しません</p>
                <div>
                    <div class="select-billing" v-if="clinicList.length > 0">
                        <div class="select-billing-main" v-for="clinic in clinicList" :value="clinic.code" :key="clinic.code">
                            <input type="radio" :value="clinic.code" v-model="selectedClinic"/>
                            <div class="select-billing-item">
                                <label>出庫先名：{{ clinic.name }}</label>
                                <label>住所：{{ clinic.address }}</label>
                                <label>電話番号：{{ clinic.number }}</label>
                            </div>
                        </div>                        
                    </div>                
                </div>                                
            </div>
            <!--/.modal-content-->
        </div>
        <!--/.modal-->
    </modal>
</template>
<script>
export default {
    name: 'SelectClinicModal',
    props: {
        propsName: String, // ヘッダーとサイドバーとバナーで重複表示を避けるため
        propsClinics: Array,
        propsSelectedClinic: Object
    },
    watch: {
        propsClinics: function (value) {
            var list = [];            
            if (value) {
                value.forEach(function (item) {
                    list.push(item);                
                });            
            }            
            this.clinicList = list;            
        }
    },
    data () {
        return  {
            clinicList: [],            
        }
    },
    computed: {                
        selectedClinic: {
            get () {
                return this.propsSelectedClinic ? this.propsSelectedClinic.code : "";
            },
            set (selectedClinicCode) {
                var selectedClinic = null;
                for (let i = 0; i < this.clinicList.length; i++) {
                    if (selectedClinicCode == this.clinicList[i].code) {                        
                        selectedClinic = this.clinicList[i];
                        break;
                    }
                }                                        
                this.$emit("selectedClinic", selectedClinic);
            }
        },        
    },
    methods: {
        show() {            
            this.disablePageScroll();            
            this.$modal.show(this.propsName);
        },
        hide() {
            this.enablePageScroll();
            this.$modal.hide(this.propsName);
        },        
    },
}
</script>
  


// WEBPACK FOOTER //
// src/components/SelectClinicModal.vue